const { EventTarget } = require('../../event-target-shim/dist/event-target-shim');

window.EventTargetShim = EventTarget;

require('./lib/AppConnector');
require('./lib/modules/AppPermissions');
require('./lib/modules/Camera');
require('./lib/modules/ConnectivityMonitor');
require('./lib/modules/FacebookAnalytics');
require('./lib/modules/FirebaseAnalytics');
require('./lib/modules/Http');
require('./lib/modules/InAppBrowser');
require('./lib/modules/Keychain');
require('./lib/modules/Linking');
require('./lib/modules/Push');
require('./lib/modules/SplashScreen');
require('./lib/modules/StatusBar');
require('./lib/modules/Geolocation');
require('./lib/modules/PayPalRiskCheck');

module.exports = window.App;
